import React from 'react';
import AutenticacaoConsumer from '../../providers/autenticacao/AutenticacaoConsumer';
import { Loading } from '../../presentations';

function CallbackPage() {
    return (<AutenticacaoConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return (<Loading />);
        }}
    </AutenticacaoConsumer>);
}

export default CallbackPage;